function googleTranslateElementInit() {
  new google.translate.TranslateElement({
      pageLanguage: 'en',
      includedLanguages: 'en,fr,es,it',
      layout: google.translate.TranslateElement.InlineLayout.STANDARD
  }, 'google_translate_element_header');
 
}

function initializeTranslateWidget() {
  return new Promise(resolve => {
      setTimeout(() => {
          var selectField = document.querySelector(".goog-te-combo");
          if (selectField) {
              //sortOptions(selectField)
              changeLangToISO(selectField);
              selectField.addEventListener('change', () => {
                setTimeout(() => {
                    changeLangToISO(selectField);
                }, 100);
              });

              Array.from(document.querySelector('.desktop-localization-wrapper .goog-te-gadget').childNodes).forEach(function(node) {
                  if (node.nodeType === Node.TEXT_NODE) {
                      document.querySelector('.desktop-localization-wrapper .goog-te-gadget').removeChild(node);
                  }
              });
          }
          setTimeout(() => {
            document.getElementById('google_translate_element_header').style.display = 'block';
          }, 1000);
          resolve();
      }, 1200);
  });
}

function changeLangToISO(el) {
  setTimeout(() => {
      el.querySelectorAll('option').forEach(function(option) {
          if (option.value === '') {
            option.textContent = 'EN';
          }
          else {
            option.textContent = option.value.toUpperCase();
          }
      });
  }, 1000);
}

function sortOptions(selectField) {
    const optionsArray = Array.from(selectField.options);
    optionsArray.sort((a, b) => a.value.localeCompare(b.value));
  
    selectField.innerHTML = '';
    optionsArray.forEach(option => {
      selectField.appendChild(option);
    });
  }
